import type { RuleKind } from "./api";

/** The event names as the pages print them ("Quoting stopped", "Daily cap high"). */
export const EVENT_NAMES: Record<RuleKind, string> = {
  "quoting-stopped": "Quoting stopped",
  "treasury-low": "Treasury low",
  "allowance-low": "Allowance low",
  "daily-cap-high": "Daily cap high",
  fill: "Fill",
  "missed-order": "Missed order",
};

/** A rule's name on Notifications: as its events, except the fill rule, which fires on each one. */
export const RULE_NAMES: Record<RuleKind, string> = { ...EVENT_NAMES, fill: "Each fill" };
